import * as React from 'react'
import './style.less'
import {Button} from 'telstra-ui/components/button/Button'
import Icon from 'telstra-ui/components/icons/Icon'
import {Routes, shouldEnableSubmitBugLink} from '@applications/mobile-data-usage-meter'
import {loading} from '@redux/actions/loading'
import {connect} from 'react-redux'

interface INPErrorBoundaryState {
  hasError: boolean
}

interface INPErrorBoundaryDispatchProps {
  hideGlobalSpinner: () => void
  children?: React.ReactNode
}
interface INPErrorBoundaryOwnProps {
  hideGlobalSpinner?: () => void
  children?: React.ReactNode
}
class NPErrorBoundaryComponent extends React.Component<
  INPErrorBoundaryOwnProps,
  INPErrorBoundaryState
> {
  constructor(props) {
    super(props)
    this.state = {hasError: false}
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {hasError: true}
  }

  private tryAgain = () => window.location.reload()

  private submitABugURL = () => {
    if (shouldEnableSubmitBugLink()) {
      return (
        <>
          <span>If this error persists please</span>{' '}
          <a href={Routes.SubmitABugURL}>
            <span>submit a bug</span>.
          </a>
        </>
      )
    }
    return null
  }

  private tryAgainComponent = (
    <div className="tc-mobility">
      <div className="tc-mobility-error-boundary-page-center">
        <div className="tc-mobility-error-boundary-container">
          <div className="tc-mobility-error-boundary-cloud-icon">
            <svg className="icon-size">
              <Icon name="icon-system-server-error" />
            </svg>
          </div>
          <span className="tc-mobility-error-boundary-failed-text">
            Failed to load the requested resource, {this.submitABugURL()}
          </span>
          <div className="tc-mobility-error-boundary-try-again">
            <Button onClick={this.tryAgain}>Try again</Button>
          </div>
        </div>
      </div>
    </div>
  )

  render() {
    if (this.state.hasError) {
      this.props.hideGlobalSpinner()
      return this.tryAgainComponent
    }

    return this.props.children
  }
}

const mapDispatchToProps = (dispatch): INPErrorBoundaryDispatchProps => {
  return {
    hideGlobalSpinner: () => dispatch(loading(false)),
  }
}

export const NPErrorBoundary = connect<
  null,
  INPErrorBoundaryDispatchProps,
  INPErrorBoundaryOwnProps,
  INPErrorBoundaryState
>(
  null,
  mapDispatchToProps,
)(NPErrorBoundaryComponent)
